import Swal from 'sweetalert2';
import Rails from '@rails/ujs';

const showConfirmationDialog = (element) => {
  const template = element.getAttribute('data-confirm-template');
  const text = element.getAttribute('data-confirm-text');
  const cancelText = element.getAttribute('data-cancel-text');
  const title = element.getAttribute('data-title-template');
  const containerClass = element.getAttribute('data-container-class');

  Swal.fire({
    html: template,
    title,
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonText: text || 'Zgadzam się',
    confirmButtonColor: '#1E88E5',
    cancelButtonText: cancelText || 'Anuluj',
    cancelButtonColor: '#F3F2FD',
    customClass: {
      container: containerClass,
    },
  }).then((result) => {
    if (result.isConfirmed) {
      element.removeAttribute('data-confirm-template');
      element.click();
    }
  });
};

const allowAction = (element) => {
  if (element.getAttribute('data-confirm-template') === null) {
    return true;
  }

  showConfirmationDialog(element);
  return false;
};

function handleConfirm(element) {
  if (!allowAction(this)) {
    Rails.stopEverything(element);
  }
}

Rails.delegate(document, 'a[data-confirm-template]', 'click', handleConfirm);
Rails.delegate(document, 'button[data-confirm-template]', 'click', handleConfirm);
